import React, {ReactNode} from 'react';

import {LabelText, LabelContainer} from './styled';

interface Props {
    text?: string;
    hasError?: boolean;
    isValid?: boolean;
    children: ReactNode;
    className?: string;
    isRequired?: boolean;
    updatedStyle?: boolean;
}

export function Label({
    text,
    hasError,
    isValid,
    children,
    className,
    isRequired = false,
    updatedStyle = false,
}: Props) {
    return (
        <>
            {text ? (
                <LabelContainer className={className}>
                    <LabelText
                        hasError={hasError}
                        isValid={isValid}
                        isRequired={isRequired}
                        updatedStyle={updatedStyle}
                    >
                        {text}
                    </LabelText>
                    {children}
                </LabelContainer>
            ) : (
                children
            )}
        </>
    );
}
